import { render } from "./RegularButton.vue?vue&type=template&id=6c312ce5&scoped=true"
import script from "./RegularButton.vue?vue&type=script&lang=js"
export * from "./RegularButton.vue?vue&type=script&lang=js"

import "./RegularButton.vue?vue&type=style&index=0&id=6c312ce5&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c312ce5"]])

export default __exports__